
/*
 * PAWS & PEARLS
 * SECRET SKY — NIGHT CRICKETS V1
 *
 * Independent nocturnal audio layer.
 *
 * The existing night effect begins with
 * Lilla's retreat. Crickets wait until
 * after the sky has become fully dark.
 *
 * Does not change the House Sound system,
 * Chocolate Waltz, wind, daytime birds,
 * balloon, fireflies or other animations.
 */

(function () {
  'use strict';

  var stage = document.getElementById(
    'pp-muse-balloon-stage'
  );

  var sky = document.getElementById(
    'pp-muse-secret-sky'
  );

  var balloon = stage &&
    stage.querySelector('button.pp-balloon');

  if (
    !stage ||
    !sky ||
    !balloon ||
    stage.dataset.ppNightCricketsV1 === '1'
  ) return;

  stage.dataset.ppNightCricketsV1 = '1';

  var AUDIO_URL =
    'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/Paws_Pearls_Secret_Sky_Night_Crickets_Audition_50s.mp3?v=1793173925';

  // Adjustable settings.
  var PEAK_VOLUME = 0.10;

  var SILENT_VOLUME = 0.001;

  // Night reaches full darkness roughly
  // five seconds after Lilla's retreat.
  // Wait longer to avoid daytime crickets.
  var AFTER_RETREAT_MS = 7500;

  // Gentle arrival of nighttime ambience.
  var FADE_IN_MS = 4000;

  // Safety timeout if night never arrives.
  var MAX_WAIT_MS = 110000;

  var audio = null;
  var ticker = 0;

  var running = false;
  var disposed = false;

  var launchedAt = 0;
  var retreatSeenAt = 0;
  var fullNightAt = 0;

  var actualVolume = SILENT_VOLUME;

  function houseAllowsSound() {
    var house = window.ppHouseSound;

    if (
      !house ||
      typeof house.isEnabled !== 'function'
    ) return false;

    try {
      return house.isEnabled() === true;
    } catch (_error) {
      return false;
    }
  }

  function hasNightEffect() {
    // Recognises the existing Enchanted Night
    // V1, V1.1 or V1.2 script references.

    return !!document.querySelector(
      'script[src*="pp-muse-enchanted-night-fireflies-v1"]'
    );
  }

  function lillaIsRetreating() {
    var controller =
      window.ppMuseLillaZebraV1;

    if (
      !controller ||
      typeof controller.getStatus !== 'function'
    ) return false;

    try {
      var state = controller.getStatus();

      return !!(
        state &&
        state.active &&
        state.phase === 'retreat'
      );

    } catch (_error) {
      return false;
    }
  }

  function skyIsInView() {
    var rect = sky.getBoundingClientRect();

    var wrapper = document.querySelector(
      '.page-wrapper'
    );

    var bounds = wrapper
      ? wrapper.getBoundingClientRect()
      : {
          top: 0,
          left: 0,
          right: window.innerWidth,
          bottom: window.innerHeight
        };

    var left = Math.max(0, bounds.left);

    var right = Math.min(
      window.innerWidth,
      bounds.right
    );

    var top = Math.max(0, bounds.top);

    var bottom = Math.min(
      window.innerHeight,
      bounds.bottom
    );

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > left &&
      rect.left < right &&
      rect.bottom > top &&
      rect.top < bottom
    );
  }

  function stop() {
    running = false;

    if (ticker) {
      clearInterval(ticker);
      ticker = 0;
    }

    if (audio) {
      try {
        audio.pause();
        audio.currentTime = 0;
        audio.volume = SILENT_VOLUME;
      } catch (_error) {}
    }
  }

  function tick() {
    if (!running || disposed) return;

    if (
      !houseAllowsSound() ||
      document.hidden
    ) {
      stop();
      return;
    }

    var now = performance.now();

    // Observe the actual Lilla animation.
    // It initiates the existing nightfall.

    if (
      !retreatSeenAt &&
      lillaIsRetreating()
    ) {
      retreatSeenAt = now;
    }

    // Only allow crickets after the
    // full-darkness safety interval.

    if (
      !fullNightAt &&
      retreatSeenAt &&
      now - retreatSeenAt >= AFTER_RETREAT_MS
    ) {
      fullNightAt = now;
    }

    // If the night transition never begins,
    // the crickets remain silent.

    if (
      !fullNightAt &&
      now - launchedAt > MAX_WAIT_MS
    ) {
      stop();
      return;
    }

    var targetVolume = SILENT_VOLUME;

    if (
      fullNightAt &&
      skyIsInView()
    ) {
      var fade = Math.min(
        1,
        (now - fullNightAt) / FADE_IN_MS
      );

      // Smooth and restrained fade.
      fade = fade * fade * (3 - 2 * fade);

      targetVolume =
        SILENT_VOLUME +
        (PEAK_VOLUME - SILENT_VOLUME) *
        fade;
    }

    // Gentle adjustment as the visitor
    // enters or leaves the night sky.

    actualVolume +=
      (targetVolume - actualVolume) * 0.19;

    if (audio) {
      audio.volume = Math.min(
        1,
        Math.max(0, actualVolume)
      );
    }
  }

  function onBalloonClick() {
    if (
      disposed ||
      !houseAllowsSound()
    ) return;

    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) return;

    // Never produce nighttime sounds
    // without the existing night controller.

    if (!hasNightEffect()) {
      console.warn(
        '[P&P Night Crickets] Night effect not found; remaining silent.'
      );
      return;
    }

    stop();

    if (!audio) {
      audio = new Audio(AUDIO_URL);
      audio.preload = 'auto';
      audio.loop = true;
    }

    try {
      audio.currentTime = 0;
      audio.volume = SILENT_VOLUME;

      actualVolume = SILENT_VOLUME;

      launchedAt = performance.now();

      retreatSeenAt = 0;
      fullNightAt = 0;

      running = true;

      // Browser audio permission comes
      // from the actual balloon click.
      //
      // The recording remains virtually
      // silent until full night.

      var attempt = audio.play();

      if (
        attempt &&
        typeof attempt.catch === 'function'
      ) {
        attempt.catch(function (error) {
          if (!running) return;

          console.warn(
            '[P&P Night Crickets] Playback unavailable:',
            error
          );

          stop();
        });
      }

      ticker = setInterval(tick, 120);

    } catch (error) {
      console.warn(
        '[P&P Night Crickets] Could not start:',
        error
      );

      stop();
    }
  }

  function onHouseChange() {
    if (!houseAllowsSound()) stop();
  }

  function onVisibilityChange() {
    if (document.hidden) stop();
  }

  function onPageHide() {
    stop();
  }

  function onSectionUnload(event) {
    if (
      !event ||
      !event.target ||
      !(
        event.target.contains(stage) ||
        event.target.contains(sky)
      )
    ) return;

    disposed = true;
    stop();

    balloon.removeEventListener(
      'click',
      onBalloonClick
    );

    document.removeEventListener(
      'pp:house-sound-change',
      onHouseChange
    );

    window.removeEventListener(
      'pp:house-sound-change',
      onHouseChange
    );

    document.removeEventListener(
      'visibilitychange',
      onVisibilityChange
    );

    document.removeEventListener(
      'shopify:section:unload',
      onSectionUnload
    );

    window.removeEventListener(
      'pagehide',
      onPageHide
    );
  }

  balloon.addEventListener(
    'click',
    onBalloonClick
  );

  document.addEventListener(
    'pp:house-sound-change',
    onHouseChange
  );

  window.addEventListener(
    'pp:house-sound-change',
    onHouseChange
  );

  document.addEventListener(
    'visibilitychange',
    onVisibilityChange
  );

  document.addEventListener(
    'shopify:section:unload',
    onSectionUnload
  );

  window.addEventListener(
    'pagehide',
    onPageHide
  );

})();
